var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-check-green",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.375000, 0.375000)",
    fill: "#95C83F",
    fillRule: "nonzero",
    id: "\\uF058"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375,3.421875 C5.65625,1.140625 8.40625,0 11.625,0 C14.84375,0 17.5859375,1.1328125 19.8515625,3.3984375 C22.1171875,5.6640625 23.25,8.40625 23.25,11.625 C23.25,14.84375 22.1171875,17.5859375 19.8515625,19.8515625 C17.5859375,22.1171875 14.84375,23.25 11.625,23.25 C8.40625,23.25 5.6640625,22.1171875 3.3984375,19.8515625 C1.1328125,17.5859375 0,14.84375 0,11.625 C0,8.40625 1.125,5.671875 3.375,3.421875 Z M11.625,21.75 C14.4375,21.75 16.828125,20.7578125 18.796875,18.7734375 C20.765625,16.7890625 21.75,14.40625 21.75,11.625 C21.75,8.8125 20.7578125,6.421875 18.7734375,4.453125 C16.7890625,2.484375 14.40625,1.5 11.625,1.5 C8.8125,1.5 6.421875,2.4921875 4.453125,4.4765625 C2.484375,6.4609375 1.5,8.84375 1.5,11.625 C1.5,14.4375 2.4921875,16.828125 4.4765625,18.796875 C6.4609375,20.765625 8.84375,21.75 11.625,21.75 Z M18.28125,8.859375 L9.796875,17.25 C9.546875,17.53125 9.28125,17.53125 9,17.25 L4.96875,13.171875 C4.71875,12.921875 4.71875,12.65625 4.96875,12.375 L5.390625,12 C5.640625,11.75 5.90625,11.75 6.1875,12 L9.421875,15.28125 L17.0625,7.640625 C17.34375,7.390625 17.609375,7.40625 17.859375,7.6875 L18.28125,8.0625 C18.53125,8.34375 18.53125,8.609375 18.28125,8.859375 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGreen);
export default __webpack_public_path__ + "static/media/icon-check-green.f2429a1d.svg";
export { ForwardRef as ReactComponent };